/**
 * Strictly necessary cookie used to associate flowcodes w/ anon users. Should not be forwarded to any third party services.
 * Note: this change is waiting for approval - DF
 */
export const ANONYMOUS_SESSION_ID = 'ANONYMOUS_SESSION_ID'
/**
 * Functional cookie used to identify a user. Can be forwarded to third party services with user consent.
 */
export const BROWSER_SESSION_ID = 'BROWSER_SESSION_ID'
